__turbopack_export_value__({
  "wrapper": "OrderCallWrapper-module-scss-module__DeBdza__wrapper",
});
